<template>
  <section class="section" id="transactions-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <purchases-invoices-title
        @update-dates="updateDates"
        @update-merchant-store="updateMerchantStore"
        @update-field="updateField"
        @update-filter="updateFilter"
        @get-purchases-invoices="getPurchasesInvoices"
        @sync-invoices="syncInvoices"
      />

      <h2
        v-if="purchasesInvoicesQty === 0"
        class="subtitle has-text-centered is-spaced"
        style="margin-top: 5rem;"
      >
        {{ $t("invoice.noInvoices") }}
      </h2>

      <div v-else>
        <div>
          <b-pagination
            :total="purchasesInvoicesQty"
            v-model="current"
            order="is-centered"
            :per-page="perPage"
            aria-next-label="Próxima página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página atual"
            @change="changePage"
          ></b-pagination>

          <p class="has-text-centered" style="margin-bottom: 1rem;">
            {{ $t("invoice.showing") }} {{ perPage }}
            {{ $t("invoice.invoicesPerPage") }}
          </p>

          <p
            class="has-text-centered"
            style="margin-bottom: 1rem; font-weight: bolder; font-size: 1.5rem;"
            v-show="merchantStoreName != ''"
          >
            {{ merchantStoreName }}
          </p>

          <purchases-invoices-table
            :purchases-invoices="purchasesInvoices"
            :show-buyer="!merchantStoreName"
            @is-loading="loading"
            @download-invoice="downloadInvoice"
          />
          <br />

          <b-pagination
            :total="purchasesInvoicesQty"
            v-model="current"
            order="is-centered"
            :per-page="perPage"
            aria-next-label="Próxima página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página atual"
            @change="changePage"
          ></b-pagination>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import { mapGetters } from "vuex";
import purchasesInvoicesTitle from "./PurchasesInvoicesTitle";
import purchasesInvoicesTable from "./purchases-invoices-table/PurchasesInvoicesTable";

export default {
  mixins: [common, mask],

  components: {
    purchasesInvoicesTitle,
    purchasesInvoicesTable
  },

  data() {
    return {
      isLoading: false,
      dates: [],
      merchantStore: "",
      merchantStoreName: "",
      current: 1,
      perPage: 100,
      transactionId: "",
      filter: "transactions-payments"
    };
  },

  methods: {
    getPurchasesInvoices(skip) {
      if (isNaN(skip)) {
        skip = (this.current - 1) * this.perPage;
      }

      this.seeDetails = false;
      this.isLoading = true;
      this.$store
        .dispatch("getPurchasesInvoices", {
          beginDate: this.dates[0],
          endDate: this.dates[1],
          skip,
          limit: this.perPage
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.currentCurrency = this.currency;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    downloadInvoice(data) {
      this.$store
        .dispatch("downloadInvoice", {
          access_key: data.access_key
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    syncInvoices() {
      this.isLoading = true;

      this.$store
        .dispatch("syncInvoices")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.dialog.alert({
              title: this.$t("invoice.syncStarted"),
              message: this.$t("invoice.message"),
              confirmText: "Ok",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    changePage(p) {
      const skip = (p - 1) * this.perPage;
      this.getPurchasesInvoices(skip);
    },

    updateMerchantStore(ms) {
      this.merchantStore = ms.split("||")[0];
      this.merchantStoreName = ms.split("||")[1];
    },

    updateDates(dates) {
      this.dates[0] = dates
        ? this.moment(dates[0]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");

      this.dates[1] = dates
        ? this.moment(dates[1]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");
    },

    updateField(data) {
      this[data.field] = data.value;
    },

    updateFilter(filter) {
      this.filter = filter;
    },

    loading(value) {
      this.isLoading = value;
    }
  },

  computed: {
    ...mapGetters(["purchasesInvoices", "purchasesInvoicesQty"])
  },

  mounted() {
    this.updateDates();
    this.getPurchasesInvoices();
  }
};
</script>

<style scoped>
#transactions-panel {
  margin-top: 3rem;
  min-height: 100vh;
  background-color: hsl(0, 0%, 96%);
}
</style>
